module.exports = __webpack_public_path__ + "static/gallery8-4c43c1fb59446e5fdfa26f8e214f58ce.jpg";